var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhatsHappeninginline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "m0 0 32.174 14L64 0v30L32.254 16 0 30z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 3v8m40-8v8"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M3 17h58"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7 7h50a4 4 0 0 1 4 4v44a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 23)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 15,
  r: 17,
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 15,
  r: 23,
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m32 41.36-7.053 5.148 2.716-8.299-7.076-5.117 8.733.019L32 24.8l2.68 8.31 8.733-.018-7.076 5.117 2.716 8.3z"
}))));
export default SvgWhatsHappeninginline;